export const site = {
  title: `Thomas Lai`,
  titleDefault: `Thomas Lai`,
  url: `https://www.tlai.io`, // Without a trailing slash!
  dataDomain: `tlai.io`,
  description: `Thomas is a software engineer currently working as a Software Engineer Consultant for Allen Hamilton.`,
  image: `/social/default-og-image.jpg?v=1`,
  twitter: `@`,
}
